var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card-text', [_vm.loading ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "7"
    }
  }, [_c('v-skeleton-loader', {
    attrs: {
      "type": "table-row@3"
    }
  })], 1)], 1) : _vm._e(), !_vm.loading ? _c('div', {
    staticStyle: {
      "overflow": "auto",
      "border-left": "thin solid rgba(255, 255, 255, 0.18) !important"
    }
  }, [_c('v-data-table', {
    staticClass: "table__lined",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "items-per-page": 20
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn(headerProps) {
        return [_c('thead', [_c('tr', [_c('th'), _c('th', {
          staticClass: "text-center",
          attrs: {
            "colspan": "6"
          }
        }, [_vm._v("Входящие")]), _c('th', {
          staticClass: "text-center",
          attrs: {
            "colspan": "3"
          }
        }, [_vm._v("Исходящие")]), _c('th')])])];
      }
    }, {
      key: "body",
      fn: function fn(_ref) {
        var items = _ref.items;
        return [_c('tbody', _vm._l(items, function (item) {
          return _c('tr', {
            key: item.operatorId
          }, [_c('td', [_vm._v(_vm._s(item.operatorName))]), _c('td', [_vm._v(_vm._s(item.incomingTotal))]), _c('td', [_vm._v(_vm._s(item.incomingAnswered))]), _c('td', [_vm._v(_vm._s(item.incomingMissed))]), _c('td', [_c('span', {
            class: _vm.getMissedColor(item.missedPercent)
          }, [_vm._v(" " + _vm._s(Math.round(item.missedPercent)) + "% ")])]), _c('td', [_vm._v(_vm._s(_vm.formatSeconds(item.avgAnswerSeconds)))]), _c('td', [_vm._v(_vm._s(_vm.formatSeconds(item.avgTalkSecondsIncoming)))]), _c('td', [_vm._v(_vm._s(item.outgoingTotal))]), _c('td', [_vm._v(_vm._s(item.outgoingAnswered))]), _c('td', [_vm._v(_vm._s(_vm.formatSeconds(item.avgTalkSecondsOutgoing)))]), _c('td', [_vm._v(_vm._s(_vm.formatSeconds(item.totalTalkSecondsAll)))])]);
        }), 0)];
      }
    }], null, false, 2137393900)
  })], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }